import { convertMinutesToHours } from '@nile/mangifera/src/Utils/helpers';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Popover } from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import envConfig from '@nile/home/src/Config/env';
import React, { useCallback, useState, useContext } from 'react';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';

const Wrap = styled.div.attrs({
  className: 'flex center'
})``;

function HoursMinutesCell(props) {
  const { cell, intl } = props;
  const allProps = cell.column;
  const rowData = cell?.row?.original || {};
  const { view } = allProps;

  return (
    <Wrap>
      <div className="ellipsis flex center ">
        {convertMinutesToHours(Number(cell?.value || 0))}
      </div>
    </Wrap>
  );
}

export default injectIntl(HoursMinutesCell);
